import { formatNumber } from "accounting"
import { Flex, Tag, Typography } from "antd"
import dayjs from "dayjs"
import { useTranslation } from "react-i18next"

import Private from "../../../../../Components/Private"
import Icon from "../../../../../Icon"
import { dateFormat } from "../../../../../Utils/utils"
import { OUTCOME_META } from "../../constants/outcomes"
import { CE_PROGRAM_META } from "../../constants/programs"

import styles from "./styles.module.less"

const { Text } = Typography

const CaseCard = ({ record, onOpen }) => {
  const { t } = useTranslation()
  const program = CE_PROGRAM_META[record.program]
  const outcome = OUTCOME_META[record.outcome]

  return (
    <Flex
      vertical
      gap={8}
      className={styles.card}
      role="button"
      tabIndex={0}
      onClick={() => onOpen(record.id)}
      data-testid={`deflect-ce-case-card-${record.id}`}
    >
      <Flex justify="space-between" align="center">
        <Text strong>{dayjs(record.date).format(dateFormat)}</Text>
        {program && (
          <Flex justify="center" gap={4}>
            {program.iconType && (
              <Icon type={program.iconType} style={{ fontSize: 20, lineHeight: 1 }} />
            )}
            <Text strong>{t(program.name)}</Text>
          </Flex>
        )}
      </Flex>
      <Flex justify="space-between" align="center">
        <Text type="secondary">{record.card ? <Private>{record.card}</Private> : "—"}</Text>
        <Text strong>
          <Private>${formatNumber(record.amount ?? 0, 2, ",")}</Private>
        </Text>
      </Flex>
      <Flex justify="space-between" align="center">
        {outcome ? (
          <Tag color={outcome.color} style={{ margin: 0 }}>
            {t(outcome.label)}
          </Tag>
        ) : (
          <span />
        )}
        <Text type="secondary" style={{ fontSize: 12 }}>
          {t("Fee")} <Private>${formatNumber(record.fee_charged ?? 0, 2, ",")}</Private>
        </Text>
      </Flex>
    </Flex>
  )
}

export default CaseCard
